module.exports = __webpack_public_path__ + "img/car-purple.d3da9522.svg";